var reservedPrefix = require("./reservedPrefix");

module.exports = reservedPrefix + "_";
